import * as planogramsShort from './short'

import * as products from 'app/mocks/data/catalogue/products/list'

import { newDateFormatted } from 'app/utils/date'

import { Planogram } from 'app/types/machines/planogram'

export const planogram1: Planogram = {
    ...planogramsShort.planogramShort1,
    selections: [
        // Tray 8
        {
            id: 1,
            mapping: '01',
            x_position: 0,
            y_position: 7,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product1,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(-4),
                    weight: 400,
                },
                {
                    position: 2,
                    bbd: newDateFormatted(4),
                    weight: 550,
                },
            ],
        },

        // Tray 7
        {
            id: 2,
            mapping: '02',
            x_position: 0,
            y_position: 6,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product1,
            articles: [
                {
                    position: 2,
                    bbd: newDateFormatted(3),
                    weight: 200,
                },
                {
                    position: 1,
                    bbd: newDateFormatted(3),
                    weight: 100,
                },
            ],
        },
        {
            id: 3,
            mapping: '03',
            x_position: 1,
            y_position: 6,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product1,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(3),
                    weight: 100,
                },
                {
                    position: 2,
                    bbd: newDateFormatted(3),
                    weight: 100,
                },
            ],
        },
        {
            id: 4,
            mapping: '04',
            x_position: 2,
            y_position: 6,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product4,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(0),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(1),
                },
                {
                    position: 3,
                    bbd: newDateFormatted(3),
                },
            ],
        },

        // Tray 6
        {
            id: 5,
            mapping: '05',
            x_position: 0,
            y_position: 5,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product1,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(-2),
                    weight: 100,
                },
                {
                    position: 2,
                    bbd: newDateFormatted(0),
                    weight: 200,
                },
                {
                    position: 3,
                    bbd: newDateFormatted(3),
                    weight: 300,
                },
            ],
        },
        {
            id: 6,
            mapping: '06',
            x_position: 1,
            y_position: 5,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product1,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(1),
                    weight: 300,
                },
            ],
        },
        {
            id: 7,
            mapping: '07',
            x_position: 2,
            y_position: 5,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product1,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(4),
                    weight: 400,
                },
            ],
        },
        {
            id: 8,
            mapping: '08',
            x_position: 3,
            y_position: 5,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product1,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(5),
                    weight: 100,
                },
                {
                    position: 2,
                    bbd: newDateFormatted(6),
                    weight: 200,
                },
                {
                    position: 3,
                    bbd: newDateFormatted(10),
                    weight: 300,
                },
                {
                    position: 4,
                    bbd: newDateFormatted(10),
                    weight: 400,
                },
            ],
        },
        {
            id: 9,
            mapping: '09',
            x_position: 4,
            y_position: 5,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product1,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(3),
                    weight: 100,
                },
                {
                    position: 2,
                    bbd: newDateFormatted(4),
                    weight: 200,
                },
            ],
        },

        // Tray 5
        {
            id: 10,
            mapping: '10',
            x_position: 0,
            y_position: 4,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product2,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(6),
                    weight: 100,
                },
                {
                    position: 2,
                    bbd: newDateFormatted(6),
                    weight: 200,
                },
                {
                    position: 3,
                    bbd: newDateFormatted(6),
                    weight: 300,
                },
                {
                    position: 4,
                    bbd: newDateFormatted(7),
                    weight: 200,
                },
            ],
        },
        {
            id: 11,
            mapping: '11',
            x_position: 1,
            y_position: 4,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product2,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(2),
                    weight: 100,
                },
                {
                    position: 2,
                    bbd: newDateFormatted(8),
                    weight: 200,
                },
                {
                    position: 3,
                    bbd: newDateFormatted(8),
                    weight: 300,
                },
                {
                    position: 4,
                    bbd: newDateFormatted(8),
                    weight: 400,
                },
                {
                    position: 5,
                    bbd: newDateFormatted(8),
                    weight: 400,
                },
                {
                    position: 6,
                    bbd: newDateFormatted(8),
                    weight: 400,
                },
                {
                    position: 7,
                    bbd: newDateFormatted(8),
                    weight: 400,
                },
                {
                    position: 8,
                    bbd: newDateFormatted(8),
                    weight: 400,
                },
                {
                    position: 9,
                    bbd: newDateFormatted(8),
                    weight: 400,
                },
            ],
        },
        {
            id: 12,
            mapping: '12',
            x_position: 2,
            y_position: 4,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product2,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(-2),
                    weight: 100,
                },
                {
                    position: 2,
                    bbd: newDateFormatted(-1),
                    weight: 200,
                },
                {
                    position: 3,
                    bbd: newDateFormatted(0),
                    weight: 300,
                },
                {
                    position: 4,
                    bbd: newDateFormatted(1),
                    weight: 400,
                },
            ],
        },
        {
            id: 13,
            mapping: '13',
            x_position: 3,
            y_position: 4,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product2,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(5),
                    weight: 200,
                },
            ],
        },
        {
            id: 14,
            mapping: '14',
            x_position: 4,
            y_position: 4,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product6,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(5),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(6),
                },
                {
                    position: 3,
                    bbd: newDateFormatted(10),
                },
                {
                    position: 4,
                    bbd: newDateFormatted(10),
                },
            ],
        },
        {
            id: 15,
            mapping: '15',
            x_position: 5,
            y_position: 4,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product6,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(10),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(10),
                },
            ],
        },

        // Tray 4
        {
            id: 16,
            mapping: '16',
            x_position: 0,
            y_position: 3,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product6,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(5),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(5),
                },
            ],
        },
        {
            id: 17,
            mapping: '17',
            x_position: 1,
            y_position: 3,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product6,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(9),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(9),
                },
                {
                    position: 3,
                    bbd: newDateFormatted(9),
                },
                {
                    position: 4,
                    bbd: newDateFormatted(9),
                },
            ],
        },
        {
            id: 18,
            mapping: '18',
            x_position: 2,
            y_position: 3,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product2,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(3),
                    weight: 168,
                },
                {
                    position: 2,
                    bbd: newDateFormatted(3),
                    weight: 170,
                },
                {
                    position: 3,
                    bbd: newDateFormatted(5),
                    weight: 165,
                },
            ],
        },
        {
            id: 19,
            mapping: '19',
            x_position: 3,
            y_position: 3,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product2,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(7),
                    weight: 168,
                },
            ],
        },
        {
            id: 20,
            mapping: '20',
            x_position: 4,
            y_position: 3,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product2,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(7),
                    weight: 170,
                },
                {
                    position: 2,
                    bbd: newDateFormatted(7),
                    weight: 165,
                },
            ],
        },
        {
            id: 21,
            mapping: '21',
            x_position: 5,
            y_position: 3,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product2,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(4),
                    weight: 160,
                },
                {
                    position: 2,
                    bbd: newDateFormatted(4),
                    weight: 175,
                },
                {
                    position: 3,
                    bbd: newDateFormatted(4),
                    weight: 168,
                },
                {
                    position: 4,
                    bbd: newDateFormatted(4),
                    weight: 172,
                },
            ],
        },
        {
            id: 22,
            mapping: '22',
            x_position: 6,
            y_position: 3,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product2,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(6),
                    weight: 165,
                },
                {
                    position: 2,
                    bbd: newDateFormatted(6),
                    weight: 170,
                },
                {
                    position: 3,
                    bbd: newDateFormatted(6),
                    weight: 168,
                },
                {
                    position: 4,
                    bbd: newDateFormatted(6),
                    weight: 172,
                },
                {
                    position: 5,
                    bbd: newDateFormatted(6),
                    weight: 174,
                },
                {
                    position: 6,
                    bbd: newDateFormatted(6),
                    weight: 166,
                },
            ],
        },
        {
            id: 23,
            mapping: '23',
            x_position: 0,
            y_position: 2,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product3,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(-1),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(-1),
                },
                {
                    position: 3,
                    bbd: newDateFormatted(2),
                },
            ],
        },
        {
            id: 24,
            mapping: '24',
            x_position: 1,
            y_position: 2,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product3,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(7),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(7),
                },
            ],
        },
        {
            id: 25,
            mapping: '25',
            x_position: 2,
            y_position: 2,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product3,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(5),
                },
            ],
        },
        {
            id: 26,
            mapping: '26',
            x_position: 3,
            y_position: 2,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product3,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(3),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(3),
                },
            ],
        },
        {
            id: 27,
            mapping: '27',
            x_position: 4,
            y_position: 2,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product3,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(6),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(6),
                },
                {
                    position: 3,
                    bbd: newDateFormatted(7),
                },
                {
                    position: 4,
                    bbd: newDateFormatted(7),
                },
                {
                    position: 5,
                    bbd: newDateFormatted(7),
                },
                {
                    position: 6,
                    bbd: newDateFormatted(7),
                },
            ],
        },
        {
            id: 28,
            mapping: '28',
            x_position: 5,
            y_position: 2,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product3,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(6),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(6),
                },
                {
                    position: 3,
                    bbd: newDateFormatted(6),
                },
            ],
        },
        {
            id: 29,
            mapping: '29',
            x_position: 6,
            y_position: 2,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product3,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(4),
                },
            ],
        },
        {
            id: 30,
            mapping: '30',
            x_position: 7,
            y_position: 2,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product3,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(2),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(2),
                },
            ],
        },
        {
            id: 31,
            mapping: '31',
            x_position: 0,
            y_position: 1,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product3,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(3),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(3),
                },
                {
                    position: 3,
                    bbd: newDateFormatted(3),
                },
            ],
        },
        {
            id: 32,
            mapping: '32',
            x_position: 1,
            y_position: 1,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product3,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(10),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(10),
                },
                {
                    position: 3,
                    bbd: newDateFormatted(10),
                },
                {
                    position: 4,
                    bbd: newDateFormatted(10),
                },
                {
                    position: 5,
                    bbd: newDateFormatted(10),
                },
            ],
        },
        {
            id: 33,
            mapping: '33',
            x_position: 2,
            y_position: 1,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product3,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(7),
                },
            ],
        },
        {
            id: 34,
            mapping: '34',
            x_position: 3,
            y_position: 1,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product3,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(-2),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(-2),
                },
                {
                    position: 3,
                    bbd: newDateFormatted(-1),
                },
                {
                    position: 4,
                    bbd: newDateFormatted(0),
                },
                {
                    position: 5,
                    bbd: newDateFormatted(4),
                },
            ],
        },
        {
            id: 35,
            mapping: '35',
            x_position: 4,
            y_position: 1,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product3,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(8),
                },
            ],
        },
        {
            id: 36,
            mapping: '36',
            x_position: 5,
            y_position: 1,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product3,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(4),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(4),
                },
            ],
        },
        {
            id: 37,
            mapping: '37',
            x_position: 6,
            y_position: 1,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product3,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(-1),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(1),
                },
                {
                    position: 3,
                    bbd: newDateFormatted(2),
                },
                {
                    position: 4,
                    bbd: newDateFormatted(3),
                },
            ],
        },
        {
            id: 38,
            mapping: '38',
            x_position: 7,
            y_position: 1,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product3,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(13),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(13),
                },
            ],
        },
        {
            id: 39,
            mapping: '39',
            x_position: 8,
            y_position: 1,
            owner: 0,
            maximum_stock: 10,
            recommended_stock: 7,
            product: products.product3,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(7),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(11),
                },
                {
                    position: 3,
                    bbd: newDateFormatted(11),
                },
            ],
        },
        {
            id: 40,
            mapping: '40',
            x_position: 0,
            y_position: 0,
            owner: 0,
            maximum_stock: 7,
            recommended_stock: 7,
            product: products.product4,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(7),
                },
            ],
        },
        {
            id: 41,
            mapping: '41',
            x_position: 1,
            y_position: 0,
            owner: 0,
            maximum_stock: 7,
            recommended_stock: 7,
            product: products.product4,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(7),
                },
            ],
        },
        {
            id: 42,
            mapping: '42',
            x_position: 2,
            y_position: 0,
            owner: 0,
            maximum_stock: 7,
            recommended_stock: 7,
            product: products.product4,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(6),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(6),
                },
            ],
        },
        {
            id: 43,
            mapping: '43',
            x_position: 3,
            y_position: 0,
            owner: 0,
            maximum_stock: 7,
            recommended_stock: 7,
            product: products.product4,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(4),
                },
            ],
        },
        {
            id: 44,
            mapping: '44',
            x_position: 4,
            y_position: 0,
            owner: 0,
            maximum_stock: 7,
            recommended_stock: 7,
            product: products.product4,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(3),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(3),
                },
                {
                    position: 3,
                    bbd: newDateFormatted(3),
                },
            ],
        },
        {
            id: 45,
            mapping: '45',
            x_position: 5,
            y_position: 0,
            owner: 0,
            maximum_stock: 7,
            recommended_stock: 7,
            product: products.product4,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(-1),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(-1),
                },
                {
                    position: 3,
                    bbd: newDateFormatted(-1),
                },
            ],
        },
        {
            id: 46,
            mapping: '46',
            x_position: 6,
            y_position: 0,
            owner: 0,
            maximum_stock: 7,
            recommended_stock: 7,
            product: products.product4,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(0),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(0),
                },
            ],
        },
        {
            id: 47,
            mapping: '47',
            x_position: 7,
            y_position: 0,
            owner: 0,
            maximum_stock: 7,
            recommended_stock: 7,
            product: products.product4,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(1),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(1),
                },
                {
                    position: 3,
                    bbd: newDateFormatted(1),
                },
            ],
        },
        {
            id: 48,
            mapping: '48',
            x_position: 8,
            y_position: 0,
            owner: 0,
            maximum_stock: 7,
            recommended_stock: 7,
            product: products.product4,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(2),
                },
                {
                    position: 2,
                    bbd: newDateFormatted(2),
                },
                {
                    position: 3,
                    bbd: newDateFormatted(2),
                },
                {
                    position: 4,
                    bbd: newDateFormatted(2),
                },
                {
                    position: 5,
                    bbd: newDateFormatted(2),
                },
                {
                    position: 6,
                    bbd: newDateFormatted(2),
                },
            ],
        },
        {
            id: 49,
            mapping: '49',
            x_position: 9,
            y_position: 0,
            owner: 0,
            maximum_stock: 7,
            recommended_stock: 7,
            product: products.product4,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(4),
                },
            ],
        },
    ],
}

export const planogram2: Planogram = {
    ...planogramsShort.planogramShort2,
    selections: [
        {
            id: 1,
            mapping: '01',
            x_position: 0,
            y_position: 9,
            owner: 0,
            recommended_stock: 1,
            maximum_stock: 1,
            order: 1,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(7),
                    weight: 400,
                },
            ],
        },
        {
            id: 2,
            mapping: '02',
            x_position: 0,
            y_position: 8,
            owner: 0,
            recommended_stock: 1,
            maximum_stock: 1,
            order: 2,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(3),
                    weight: 350,
                },
            ],
        },
        {
            id: 3,
            mapping: '03',
            x_position: 0,
            y_position: 7,
            owner: 0,
            recommended_stock: 1,
            maximum_stock: 1,
            product: products.product1,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(-1),
                    weight: 320,
                },
            ],
        },
        {
            id: 4,
            mapping: '04',
            x_position: 0,
            y_position: 6,
            owner: 0,
            recommended_stock: 1,
            maximum_stock: 1,
            order: 3,
            articles: [],
        },
        {
            id: 5,
            mapping: '05',
            x_position: 0,
            y_position: 5,
            owner: 0,
            recommended_stock: 1,
            maximum_stock: 1,
            product: products.product2,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(0),
                    weight: 168,
                },
            ],
        },
        {
            id: 6,
            mapping: '06',
            x_position: 0,
            y_position: 4,
            owner: 0,
            recommended_stock: 1,
            maximum_stock: 1,
            product: products.product2,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(2),
                    weight: 175,
                },
            ],
        },
        {
            id: 7,
            mapping: '07',
            x_position: 0,
            y_position: 3,
            owner: 0,
            recommended_stock: 1,
            maximum_stock: 1,
            product: products.product3,
            articles: [],
        },
        {
            id: 8,
            mapping: '08',
            x_position: 0,
            y_position: 2,
            owner: 0,
            recommended_stock: 1,
            maximum_stock: 1,
            product: products.product3,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(3),
                },
            ],
        },
        {
            id: 9,
            mapping: '09',
            x_position: 0,
            y_position: 1,
            owner: 0,
            recommended_stock: 1,
            maximum_stock: 1,
            product: products.product3,
            articles: [],
        },
        {
            id: 10,
            mapping: '10',
            x_position: 1,
            y_position: 1,
            owner: 0,
            recommended_stock: 1,
            maximum_stock: 1,
            product: products.product3,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(4),
                },
            ],
        },
        {
            id: 11,
            mapping: '11',
            x_position: 0,
            y_position: 0,
            owner: 0,
            recommended_stock: 1,
            maximum_stock: 1,
            product: products.product4,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(10),
                },
            ],
        },
        {
            id: 12,
            mapping: '12',
            x_position: 1,
            y_position: 0,
            owner: 0,
            recommended_stock: 1,
            maximum_stock: 1,
            product: products.product4,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(4),
                },
            ],
        },
        {
            id: 13,
            mapping: '13',
            x_position: 2,
            y_position: 0,
            owner: 0,
            recommended_stock: 1,
            maximum_stock: 1,
            product: products.product4,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(1),
                },
            ],
        },
        {
            id: 14,
            mapping: '14',
            x_position: 3,
            y_position: 0,
            owner: 0,
            recommended_stock: 1,
            maximum_stock: 1,
            product: products.product4,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(-1),
                },
            ],
        },
        {
            id: 15,
            mapping: '15',
            x_position: 4,
            y_position: 0,
            owner: 0,
            recommended_stock: 1,
            maximum_stock: 1,
            product: products.product4,
            articles: [
                {
                    position: 1,
                    bbd: newDateFormatted(0),
                },
            ],
        },
    ],
}

export const planogram3: Planogram = {
    ...planogramsShort.planogramShort3,
    selections: [
        {
            id: 5_018,
            product: products.product3,
            x_position: 0,
            y_position: 4,
            mapping: '03',
            dispensation_speed: 6,
            motor_activation_time_after_dispensation: 0,
            maximum_stock: 9,
            recommended_stock: 8,
            count_to_trigger_low_stock_alarm: 2,
            width_in_millimeters: 170,
            owner: 1,
            articles: [],
        },
    ],
}

export const planogram4: Planogram = {
    ...planogramsShort.planogramShort4,
    selections: [
        {
            id: 5_019,
            product: products.product1,
            x_position: 0,
            y_position: 4,
            mapping: '01',
            dispensation_speed: 6,
            motor_activation_time_after_dispensation: 0,
            maximum_stock: 10,
            recommended_stock: 8,
            count_to_trigger_low_stock_alarm: 2,
            width_in_millimeters: 170,
            owner: 1,
            articles: [],
        },
    ],
}

export const planogram5: Planogram = {
    ...planogramsShort.planogramShort5,
    selections: [
        {
            id: 5_020,
            product: products.product1,
            x_position: 0,
            y_position: 4,
            mapping: '01',
            dispensation_speed: 6,
            motor_activation_time_after_dispensation: 0,
            maximum_stock: 10,
            recommended_stock: 8,
            count_to_trigger_low_stock_alarm: 2,
            width_in_millimeters: 170,
            owner: 1,
            articles: [],
        },
    ],
}

export const planogram6: Planogram = {
    ...planogramsShort.planogramShort6,
    selections: [
        {
            id: 5_021,
            product: products.product1,
            x_position: 0,
            y_position: 4,
            mapping: '01',
            dispensation_speed: 6,
            motor_activation_time_after_dispensation: 0,
            maximum_stock: 10,
            recommended_stock: 8,
            count_to_trigger_low_stock_alarm: 2,
            width_in_millimeters: 170,
            owner: 1,
            articles: [],
        },
    ],
}

export const planogram7: Planogram = {
    ...planogramsShort.planogramShort7,
    selections: [
        {
            id: 5_022,
            product: products.product2,
            x_position: 0,
            y_position: 4,
            mapping: '01',
            dispensation_speed: 6,
            motor_activation_time_after_dispensation: 0,
            maximum_stock: 10,
            recommended_stock: 8,
            count_to_trigger_low_stock_alarm: 2,
            width_in_millimeters: 170,
            owner: 1,
            articles: [],
        },
        {
            id: 5_555,
            product: products.product2,
            x_position: 0,
            y_position: 4,
            mapping: '01',
            dispensation_speed: 6,
            motor_activation_time_after_dispensation: 0,
            maximum_stock: 10,
            recommended_stock: 8,
            count_to_trigger_low_stock_alarm: 2,
            width_in_millimeters: 170,
            owner: 1,
            articles: [],
        },
    ],
}

export const planogram8: Planogram = {
    ...planogramsShort.planogramShort8,
    selections: [
        {
            id: 5_023,
            product: products.product2,
            x_position: 0,
            y_position: 4,
            mapping: '01',
            dispensation_speed: 6,
            motor_activation_time_after_dispensation: 0,
            maximum_stock: 10,
            recommended_stock: 8,
            count_to_trigger_low_stock_alarm: 2,
            width_in_millimeters: 170,
            owner: 1,
            articles: [],
        },
    ],
}

export const planogram9: Planogram = {
    ...planogramsShort.planogramShort9,
    selections: [
        {
            id: 5_024,
            product: products.product1,
            x_position: 0,
            y_position: 4,
            mapping: '01',
            dispensation_speed: 6,
            motor_activation_time_after_dispensation: 0,
            maximum_stock: 10,
            recommended_stock: 8,
            count_to_trigger_low_stock_alarm: 2,
            width_in_millimeters: 170,
            owner: 1,
            articles: [],
        },
    ],
}

export const planogram10: Planogram = {
    ...planogramsShort.planogramShort10,
    selections: [
        {
            id: 5_025,
            order: 1,
            x_position: 0,
            y_position: 4,
            mapping: '01',
            dispensation_speed: 6,
            motor_activation_time_after_dispensation: 0,
            maximum_stock: 10,
            recommended_stock: 8,
            count_to_trigger_low_stock_alarm: 2,
            width_in_millimeters: 170,
            owner: 1,
            articles: [],
        },
    ],
}
